module.exports = {"text":"module.exports = __webpack_public_path__ + \"static/media/done.3c02b1ab.svg\";"};
module.exports['default'] = module.exports;
